import { Link } from "react-router-dom";

import LogoSvg from "../../../assets/logo.svg";

const Logo = ({ className }: { className?: string }) => {
  return (
    <Link className={`shrink-0 ${className}`} to="/">
      <LogoImage />
    </Link>
  );
};

const LogoImage = () => (
  <img className={`h-18 w-18 bg-white`} data-testid="logo" src={LogoSvg} />
);

export { Logo, LogoImage };
